import React, { Component } from "react";
import {
  loading,
  float,
  NavbarAdmin,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  company,
  Select,
  t,
  Modal,
} from "../../components/CustomComponent.js";

// ตั้งค่า Company ID ตามที่ระบุใน cURL

export default class ServiceBOM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      active_bom_uid: null, 

      // Form States (Active BOM)
      company_id: company?.id || "",
      bom_name: "",
      work_requisition_categories_id: "",
      work_requisition_service_types_id: "",
      brand_id: "",
      is_active: "true",
      description: "",
      
      // Master Data States
      bom_list: [],     
      bom_parts: [],    
      master_parts: [], 
      uoms: [], 
      data_categories: [],
      brands: [],        // ข้อมูล Brands

      // Modals
      modal_create_bom: false,

      // Form States (Create Modal)
      new_bom_name: "",
      new_category_id: "",
      new_service_type_id: "", 
      new_brand_id: "", 
      new_description: "",
      new_is_active: "true",
    };
  }

  async componentDidMount() {
    loading(true);
    // ใช้ Promise.all เพื่อเรียก API ให้ทำงานพร้อมกัน ทำให้โหลดเร็วขึ้น
    await Promise.all([
      this.fetchPartMasters(),
      this.fetchUOMs(),
      this.fetchBOMList(),
      this.fetchCategories(),
      this.fetchBrands()
    ]);
    loading(false);
  }

  // ดึงรายการ BOM ทั้งหมด
  fetchBOMList = async () => {
    try {
      const res = await GET("admin/bom-masters", { page: 0, page_size: 10000});
      const data = res.data;
      this.setState({ bom_list: Array.isArray(data) ? data : [] });
    } catch (error) {
      console.error("Error fetching BOM List:", error);
    }
  }

  // ดึงรายการ Part Master
  fetchPartMasters = async () => {
    try {
      const res = await GET("warehouse/part-masters",{ page: 0, page_size: 10000});
      const data = res.data?.map(e=>({label: `${e.part_number} ${e.name}`, value: e.uid, uom: e.uom?.uid}));
      this.setState({ master_parts: Array.isArray(data) ? data : [] });
    } catch (error) {
      console.error("Error fetching Part Masters:", error);
    }
  }

  // ดึงรายการ UOM
  fetchUOMs = async () => {
    try {
      const res = await GET("warehouse/uoms",{ page: 0, page_size: 10000});
      const data = res.data?.map(e=>({label: e.name, value: e.uid}));
      this.setState({ uoms: Array.isArray(data) ? data : [] });
    } catch (error) {
      console.error("Error fetching Part Masters:", error);
    }
  }

  // ดึงรายการ Categories
  fetchCategories = async () => {
    try {
      const res = await GET("admin/work-requisition/categories",{ page: 0, page_size: 10000});
      const data = res.data?.map(e=>({
        ...e,
        label: e.name_th,
        value: e.uid
      }));
      this.setState({ data_categories: Array.isArray(data) ? data : [] });
    } catch (error) {
      console.error("Error fetching Categories:", error);
    }
  }

  // ดึงรายการ Brands
  fetchBrands = async () => {
    try {
      const res = await GET("warehouse/brands",{ page: 0, page_size: 10000});
      const data = res.data?.map(e=>({label: e.name, value: e.uid}));
      this.setState({ brands: Array.isArray(data) ? data : [] });
    } catch (error) {
      console.error("Error fetching Brands:", error);
    }
  }

  getServiceTypeOptions = (categoryId, categories = this.state.data_categories) => {
    const sourceCategories = Array.isArray(categories) ? categories : [];

    if (categoryId) {
      const selectedCategory = sourceCategories.find((category) => category.uid === categoryId || category.value === categoryId);
      const selectedServiceType = selectedCategory?.service_type_default;

      if (!selectedServiceType?.uid) {
        return [];
      }

      return [
        {
          ...selectedServiceType,
          value: selectedServiceType.uid,
          label: selectedServiceType.name_th || selectedServiceType.name_en || "-",
        },
      ];
    }

    const uniqueServiceTypes = new Map();
    sourceCategories.forEach((category) => {
      const serviceType = category?.service_type_default;
      if (serviceType?.uid && !uniqueServiceTypes.has(serviceType.uid)) {
        uniqueServiceTypes.set(serviceType.uid, {
          ...serviceType,
          value: serviceType.uid,
          label: serviceType.name_th || serviceType.name_en || "-",
        });
      }
    });

    return Array.from(uniqueServiceTypes.values());
  };

  handleCategoryChange = (categoryId, mode = "active") => {
    const category = this.state.data_categories.find((item) => item.uid === categoryId || item.value === categoryId);
    const serviceTypeId = category?.service_type_default?.uid || "";

    if (mode === "new") {
      this.setState({
        new_category_id: categoryId,
        new_service_type_id: serviceTypeId,
      });
      return;
    }

    this.setState({
      work_requisition_categories_id: categoryId,
      work_requisition_service_types_id: serviceTypeId,
    });
  };

  handleSelectBOM = async (bom) => {
    loading(true);
    const res = await GET("admin/bom-masters", { uid: bom.uid});
    const data = res.data;
    this.setState({
      active_bom_uid: data.uid,
      bom_name: data.name || "",
      work_requisition_categories_id: data.work_requisition_categories?.uid || "",
      work_requisition_service_types_id: data.work_requisition_service_type?.uid || "",
      brand_id: data.brand?.uid || "",
      description: data.description || "",
      is_active: data.is_active !== undefined ? String(data.is_active) : "true",
      bom_parts: data.bom_items ? data.bom_items.map(item => ({
        uid: item.uid || Math.random().toString(),
        part_id: item.part?.uid || "",
        quantity: item.quantity || 1,
        uom_id: item.uom?.uid || "",
        remark: item.remark || ""
      })) : [],
    });
    loading(false);
  }

  handleCreateNew = () => {
    this.setState({
      modal_create_bom: true,
      new_bom_name: "",
      new_category_id: "",
      new_service_type_id: "",
      new_brand_id: "",
      new_description: "",
      new_is_active: "true",
    });
  }

  // สร้าง BOM ใหม่ (POST)
  SubmitCreateBOM = async () => {
    const {company_id, new_bom_name,
    new_category_id,
    new_service_type_id,
    new_brand_id,
    new_description,
      new_is_active } = this.state;
    
    if (!this.state.new_bom_name.trim()) {
      alert("", "warning", t("warning"), t("validate_bom_name"));
      return;
    }

    if (!this.state.new_category_id) {
      alert("", "warning", t("warning"), t("validate_req_category"));
      return;
    }

    loading(true);
    try {
      const payload = {
        company_id: company_id,
        name: new_bom_name,
        work_requisition_categories_id: new_category_id || null,
        work_requisition_service_types_id: new_service_type_id || null,
        brand_id: new_brand_id || null,
        description: new_description,
        is_active: new_is_active === "true"
      };

      const res = await POST("admin/bom-masters", payload);
      
      if (res) {
        alert("#", "success", t("success"), t("create_bom_success"));
        this.setState({ modal_create_bom: false });
        await this.fetchBOMList(); 
      }
    } catch (error) {
      alert("", "error", t("error"), t("create_bom_error"));
    } finally {
      loading(false);
    }
  }

  // บันทึก/อัปเดต BOM (PUT)
  Save = async () => {
    const { company_id, active_bom_uid, bom_name, work_requisition_categories_id, work_requisition_service_types_id, brand_id, description, is_active, bom_parts } = this.state;

    if (!active_bom_uid) {
      alert("", "warning", t("warning"), t("select_bom_to_save"));
      return;
    }

    if (!bom_name.trim()) {
      alert("", "warning", t("warning"), t("please_fill_required"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_save_bom"), t("confirm"), t("cancel"))) {
      loading(true);
      try {
        const formatted_bom_items = bom_parts
          .filter(part => part.part_id)
          .map(part => ({
            part_id: part.part_id,
            quantity: Number(part.quantity) || 1,
            uom_id: part.uom_id || "", 
            remark: part.remark || ""
          }));

        const payload = {
          company_id: company_id,
          name: bom_name,
          work_requisition_categories_id: work_requisition_categories_id || null,
          work_requisition_service_types_id: work_requisition_service_types_id || null,
          brand_id: brand_id || null,
          description: description,
          is_active: is_active === "true",
          bom_items: formatted_bom_items
        };

        const res = await PUT(`admin/bom-masters/${active_bom_uid}`, payload);
        
      if (res) {
          alert("#", "success", t("success"), t("save_success"));
          await this.fetchBOMList();
        }
      } catch (error) {
        alert("", "error", t("error"), t("save_bom_error"));
      } finally {
        loading(false);
      }
    }
  }

  handleAddPartRow = () => {
    this.setState(prevState => ({
      bom_parts: [
        ...prevState.bom_parts,
        {
          uid: `temp_${Math.random().toString(36).substr(2, 9)}`,
          part_id: "",
          quantity: 1,
          uom_id: "",
          remark: ""
        }
      ]
    }));
  }

  handlePartChange = (index, field, value) => {
    const updatedParts = [...this.state.bom_parts];
    updatedParts[index][field] = value;
    this.setState({ bom_parts: updatedParts });
  }

  handleRemovePartRow = (index) => {
    const updatedParts = [...this.state.bom_parts];
    updatedParts.splice(index, 1);
    this.setState({ bom_parts: updatedParts });
  }

  renderSidebar = () => {
    const { bom_list, filter_search, active_bom_uid } = this.state;
    const filteredList = bom_list.filter(b => 
      b.name?.toLowerCase().includes(filter_search.toLowerCase())
    );

    return (
      <div className="bg-white border-end h-100 d-flex flex-column" style={{ width: '300px', minHeight: 'calc(100vh - 70px)' }}>
        <div className="p-3 border-bottom bg-light">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="fw-bold text-dark text-14">{t("service_bom_all")}</span>
          </div>
          <div className="position-relative">
            <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
            <input 
              type="text" 
              className="form-control ps-5 rounded-3 border-light text-12 py-2" 
              placeholder={t("search_bom_name")} 
              value={filter_search}
              onChange={(e) => this.setState({ filter_search: e.target.value })}
            />
          </div>
        </div>

        <div className="flex-grow-1 overflow-auto p-2">
          <div className="d-flex flex-column gap-1">
            {filteredList.map((bom) => {
              const isActive = active_bom_uid === (bom.uid || bom.id);
              return (
                <div 
                  key={bom.uid || bom.id} 
                  className={`p-3 rounded-3 pointer border transition-all ${isActive ? 'border-primary bg-primary-light shadow-sm' : 'border-transparent bg-white hover-bg-light'}`}
                  onClick={() => this.handleSelectBOM(bom)}
                >
                  <div className="fw-bold text-14 text-dark mb-1 text-truncate">{bom.name}</div>
                  <div className="d-flex align-items-center justify-content-between text-12">
                    <span className={bom.is_active ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                      {bom.is_active ? t("active") : t("inactive")}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  renderMainContent = () => {
    const { 
      uid, active_bom_uid, bom_name, work_requisition_categories_id, work_requisition_service_types_id, 
      brand_id, is_active, description, bom_parts, master_parts, uoms, 
      data_categories, brands
    } = this.state;
    const serviceTypeOptions = this.getServiceTypeOptions(work_requisition_categories_id, data_categories);

 if(!active_bom_uid) {
  return null;
 }
    return (
        <div className="flex-grow-1 bg-white d-flex flex-column" style={{ minHeight: "calc(100vh - 70px)" }}>
            {/* Main Header */}
            <div className="p-3 border-bottom d-flex justify-content-between align-items-center sticky-top bg-white z-index-1">
                <div className="d-flex align-items-center">
                    <span className="icon text-primary text-20 me-3">{"\uf0ad"}</span>
                    <div>
                        <h5 className="fw-bold mb-0 text-dark d-flex align-items-center">{bom_name || t("new_service_bom")}</h5>
                        <div className="text-secondary text-12 mt-1">{t("bom_name")}</div>
                    </div>
                </div>
                <div className="d-flex gap-2">
                    <button className="btn btn-primary fw-bold rounded-3 px-4 shadow-sm" style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }} onClick={this.Save}>
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                </div>
            </div>
            <div className="p-4 flex-grow-1 overflow-auto" style={{ backgroundColor: "#f8f9fa" }}>
                {/* Section 1: ข้อมูล Service BOM */}
                <div className="bg-white rounded-4 shadow-sm border p-4 mb-4">
                    <h6 className="fw-bold text-dark mb-4 d-flex align-items-center">
                        <span className="icon me-2 text-secondary">{"\uf044"}</span> {t("bom_info")}
                    </h6>

                    <div className="row g-4">
                        <div className="col-md-8">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("bom_name")} <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" placeholder={t("enter_bom_name")} value={bom_name} onChange={(e) => this.setState({ bom_name: e.target.value })} />
                        </div>

                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("req_category")}
                                <span className="text-danger"> *</span>
                            </label>
                            <Select
                                className="form-control"
                                placeholder={t("select_category")}
                                options={data_categories}
                                value={work_requisition_categories_id}
                                onChange={(e) => this.handleCategoryChange(e)}
                            />
                        </div>

                        {/* ----- Select Service Type ----- */}
                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold text-dark">{t("service_type")}</label>
                            <Select
                                className="form-control"
                                options={serviceTypeOptions}
                                value={work_requisition_service_types_id}
                                onChange={(e) => this.setState({ work_requisition_service_types_id: e })}
                                disabled
                                placeholder={t("select_service_type")}
                            />
                        </div>

                        {/* ----- Select Brand ----- */}
                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold text-dark">{t("brand")}</label>
                            <Select className="form-control" placeholder={t("select_brand")} options={brands} value={brand_id} onChange={(e) => this.setState({ brand_id: e })} />
                        </div>

                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold text-dark">{t("status")}</label>
                            <select className="form-select" value={is_active} onChange={(e) => this.setState({ is_active: e.target.value })}>
                                <option value="true">{t("active_with_en")}</option>
                                <option value="false">{t("inactive_with_en")}</option>
                            </select>
                        </div>
                        <div className="col-12">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("description")} / {t("note")}
                            </label>
                            <textarea className="form-control" rows="2" value={description} onChange={(e) => this.setState({ description: e.target.value })}></textarea>
                        </div>
                    </div>
                </div>

                {/* Section 2: รายการอะไหล่ใน BOM */}
                <div className="bg-white rounded-4 shadow-sm border p-4 mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold text-dark mb-0 d-flex align-items-center">
                            <span className="icon me-2 text-secondary">{"\uf0ad"}</span> {t("parts_in_bom")}
                        </h6>
                    </div>

                    <div>
                        <table className="table align-middle table-hover mb-0">
                            <thead>
                                <tr className="text-secondary text-12 border-bottom">
                                    <th className="fw-bold border-0 wpx-50 text-center">{t("no")}</th>
                                    <th className="fw-bold border-0 min-wpx-250">{t("select_part_master")}</th>
                                    <th className="fw-bold border-0 wpx-100 text-center">{t("qty")}</th>
                                    <th className="fw-bold border-0 wpx-150 text-center">{t("uom")}</th>
                                    <th className="fw-bold border-0 min-wpx-200">{t("note")}</th>
                                    <th className="fw-bold border-0 wpx-50 text-center">{t("delete")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bom_parts.length > 0 ? (
                                    bom_parts.map((part, idx) => (
                                        <tr key={part.uid} className="border-bottom">
                                            <td className="text-center text-secondary text-12">{idx + 1}</td>
                                            <td>
                                                <Select
                                                    className="form-control"
                                                    options={master_parts}
                                                    value={part.part_id}
                                                    onChange={(e, i) => {
                                                        // console.log("i.uom:", i.uom);
                                                        this.handlePartChange(idx, "part_id", e);
                                                        this.handlePartChange(idx, "uom_id", i.uom);
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input type="number" className="form-control" value={part.quantity} onChange={(e) => this.handlePartChange(idx, "quantity", e.target.value)} />
                                            </td>
                                            <td>
                                                <Select className="form-control" options={uoms} value={part.uom_id} disabled />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("note_placeholder")}
                                                    value={part.remark}
                                                    onChange={(e) => this.handlePartChange(idx, "remark", e.target.value)}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <span className="icon text-secondary pointer hover-danger transition-hover" onClick={() => this.handleRemovePartRow(idx)}>
                                                    {"\uf00d"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center py-4 text-secondary fst-italic">
                                            {t("no_parts_in_bom")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex gap-2 mt-4">
                        <button className="btn btn-white border px-3 py-2 text-dark rounded-3 fw-bold text-12 shadow-sm hover-bg-light" onClick={this.handleAddPartRow}>
                            + {t("add_new_part")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
  }

  render() {
    const { 
      modal_create_bom, new_bom_name, new_category_id, new_service_type_id, new_brand_id, new_description, new_is_active,
      data_categories, brands
    } = this.state;
    const newServiceTypeOptions = this.getServiceTypeOptions(new_category_id, data_categories);

    return (
        <div className="w-100 min-vh-100 d-flex flex-column" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />

            <div className="body px-4 py-3 border-bottom bg-white d-flex justify-content-between align-items-center">
                <div className="text-dark fw-bold d-flex align-items-center">
                    <span className="icon text-primary me-2 text-18">{"\uf0ad"}</span> S-Vibe CMMS <span className="mx-2 text-secondary fw-normal">/</span> {t("master_data")}{" "}
                    <span className="mx-2 text-secondary fw-normal">/</span> {t("service_bom")}
                </div>
                <button className="btn btn-primary px-4 py-2 fw-bold shadow-sm d-flex align-items-center rounded-pill" onClick={this.handleCreateNew}>
                    <span className="me-2">+</span> {t("new_service_bom")}
                </button>
            </div>

            <div className="d-flex flex-grow-1 overflow-hidden body">
                {this.renderSidebar()}
                {this.renderMainContent()}
            </div>

            {/* Modal: สร้าง Service BOM ใหม่ */}
            <Modal size="md" show={modal_create_bom} onHide={() => this.setState({ modal_create_bom: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-white">
                <Modal.Header className="border-bottom px-4 py-3" closeButton>
                    <h5 className="fw-bold mb-0 text-dark d-flex align-items-center">
                        <span className="me-2">+</span> {t("new_service_bom")}
                    </h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">
                            {t("bom_name")} <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" placeholder={t("enter_bom_name")} value={new_bom_name} onChange={(e) => this.setState({ new_bom_name: e.target.value })} />
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">
                            {t("req_category")} <span className="text-danger">*</span>
                        </label>
                        <Select 
                          className="form-control" 
                          placeholder={t("select_category")} 
                          options={data_categories} 
                          value={new_category_id} 
                          onChange={(e) => this.handleCategoryChange(e, "new")} 
                        />
                    </div>

                    {/* ----- Modal: Select Service Type ----- */}
                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">{t("service_type")}</label>
                        <Select
                            className="form-control"
                            options={newServiceTypeOptions}
                            value={new_service_type_id}
                            onChange={(e) => this.setState({ new_service_type_id: e })}
                            disabled
                            placeholder={t("select_service_type")}
                        />
                    </div>

                    {/* ----- Modal: Select Brand ----- */}
                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">{t("brand")}</label>
                        <Select className="form-control" placeholder={t("select_brand")} options={brands} value={new_brand_id} onChange={(e) => this.setState({ new_brand_id: e })} />
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-dark fw-bold text-14">{t("status")}</label>
                        <select className="form-select" value={new_is_active} onChange={(e) => this.setState({ new_is_active: e.target.value })}>
                            <option value="true">{t("active")}</option>
                            <option value="false">{t("inactive")}</option>
                        </select>
                    </div>

                    <div className="mb-4">
                        <label className="form-label text-dark fw-bold text-14">{t("description")}</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            placeholder={t("description_placeholder")}
                            value={new_description}
                            onChange={(e) => this.setState({ new_description: e.target.value })}
                        ></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top px-4 py-3 d-flex justify-content-end gap-2 bg-white">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create_bom: false })}>
                        {t("cancel")}
                    </button>
                    <button
                        className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={this.SubmitCreateBOM}
                    >
                        {t("create_bom")} <span className="icon ms-2">{"\uf061"}</span>
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
